module.exports = __webpack_public_path__ + "278321edc4a28fc3f2441b1472e9347a.woff";